import { Checkbox, DatePicker, Form, FormInstance, Input, Row } from "antd";
import { FileFormItem } from "../Sidebar/FileFormItem";
import { DATE_FORMAT } from "../../../../lib/constants";
import { useRules } from "../../../Account/components/View/Admin/Documents/hooks/useRules";
import { VisibilityFormItem } from "../../../Account/components/View/Admin/Documents/components/VisibilityFormItem";

type NewDetailsProps = {
  form: FormInstance;
  id: string;
};

export const NewDetails = ({ form, id }: NewDetailsProps) => {
  const { dateRule, nameRule, descriptionRule } = useRules();

  return (
    <Row className="d-block mt-4 pr-6">
      <p className="mt-0 mb-4 text-md w-500">New Document Details:</p>

      <FileFormItem id={id} />

      <Form.Item
        name={["document", "date"]}
        label="Date"
        className="mb-4"
        rules={dateRule}
      >
        <DatePicker format={DATE_FORMAT} placeholder="MM/DD/YY" />
      </Form.Item>

      <Form.Item
        name={["document", "name"]}
        label="Name"
        className="mb-4"
        rules={nameRule}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name={["document", "description"]}
        label="Description"
        className="mb-4"
        rules={descriptionRule}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name={["document", "isHolding"]}
        valuePropName="checked"
        className="mb-6 w-100"
      >
        <Checkbox>Holding Original</Checkbox>
      </Form.Item>

      <VisibilityFormItem form={form} name={["document", "visibility"]} />
    </Row>
  );
};
